import React from 'react';

import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';

import annotationTypes from 'react-scale/components/tailwind/product-examples/examples';

import sectionTitleIcons from 'react-scale/components/new-global/icons/SectionTitleIcons';

import ByAnnotation from 'react-scale/components/tailwind/product-examples/ByAnnotation';

const HowItWorks = ({ title, subtitle, productType, product, selectorStyle, link }) => (
  <div>
    <Section relative container={false} id="how-it-works" bg="bg-neutral-950">
      <div className="container">
        <SectionTitle
          overtitle="How it works"
          title={title}
          subtitle={subtitle}
          link={link}
          maxWidth
        />
        <ByAnnotation
          tabs={annotationTypes[productType]}
          selectorStyle={selectorStyle}
          product={product}
          buttonText="Run Extraction"
          color={{ instruction: 'text-neutral-300' }}
        />
      </div>
    </Section>
  </div>
);

HowItWorks.defaultProps = {
  icon: sectionTitleIcons.howItWorks,
  productType: 'video',
  product: '',
  overtitle: {
    text: 'How It Works',
    color: 'text-scale-mauve'
  },
  selectorStyle: 'normal'
};

export default HowItWorks;
